function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="M7.776 20a.741.741 0 0 0 .545-.228l7.455-7.193a.818.818 0 0 0 .254-.582.761.761 0 0 0-.254-.575L8.332 4.228A.761.761 0 0 0 7.777 4a.756.756 0 0 0-.551.222.756.756 0 0 0-.222.551.837.837 0 0 0 .218.545l6.907 6.688-6.911 6.675a.817.817 0 0 0-.218.545.756.756 0 0 0 .221.552.756.756 0 0 0 .552.221z" /></svg>;
});